const initialState = { lang: localStorage.getItem("lang") || "zh" }
export const langReducer = (prevState = initialState, action) => {
    let newState = { ...prevState }
    if (action.type === "setLanguage") {
        newState.lang = action.data
        localStorage.setItem("lang", action.data)
    }
    return newState
}